<template>
    <div>
        <dictionary-simple-table
        dictionary_link = "/product-producers"
        title = "Lista producentów"
        :numeral_text = "['producent', 'producentów', 'producentów']"
        :columns_title = "['name']"
        ></dictionary-simple-table>
    </div>
</template>

<script>
    import DictionarySimpleTable from './DictionarySimpleTable.vue';
    export default {
        components: {
            DictionarySimpleTable
        },
    }
</script>